var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-organigramme';
                    var viewUrl = 'sprite.svg#view-icon-organigramme';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?icon-organigramme#icon-organigramme';
                            viewUrl = 'sprite.svg?icon-organigramme#view-icon-organigramme';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 18 18',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };